import AsyncBoundary from '../../AsyncBoundary';
import { IOrganizationRouteParams } from '../../../routing';
import { OrganizationResource } from '@datarock/api-client';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useSuspense } from '@data-client/react';

function ErrorMessage() {
  return <span>Error</span>;
}

function Loader() {
  return <span>...</span>;
}

const OrganizationName: React.FC<
  RouteComponentProps<IOrganizationRouteParams>
> = (props) => {
  const { organizationId } = props.match.params;

  const organization = useSuspense(OrganizationResource.get, {
    id: organizationId
  });

  if (!organization) {
    return null;
  }

  return <span>{organization.name}</span>;
};

const OrganizationBreadcrumb: React.FC<
  RouteComponentProps<IOrganizationRouteParams>
> = (props) => {
  return (
    <AsyncBoundary errorFallback={ErrorMessage} loadingFallback={Loader}>
      <OrganizationName {...props} />
    </AsyncBoundary>
  );
};

export default OrganizationBreadcrumb;
